import { OhayoACLConfig } from '@ohayojp/util';

export const ACL_DEFAULT_CONFIG: OhayoACLConfig = {
  guard_url: `/403`,
};
